import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { FeatureFlagsMap, MmuFeatureFlagsService } from '../../feature-flags';
import { MmuLogger } from '../../logging';


/**
 * This guard is used to determine whether the service user was approved by Miele.
 *
 */

export function hasOrganizationApproval(): CanActivateFn | CanActivateChildFn {
  return (_, state): true | UrlTree => {


    /* @deprecated FF_userServiceOrgApproval: Remove this shortcut when the feature flag is removed. */
    const featureFlagService: MmuFeatureFlagsService = inject(MmuFeatureFlagsService);
    if (!featureFlagService.isFeatureEnabled(FeatureFlagsMap.FFUserServiceOrgApproval)) {
      return true;
    }

    const userService: MmuUserService = inject(MmuUserService);
    if (userService.isCustomerUser || userService.user.orgApproved) {
      return true;
    }

    const router: Router = inject(Router);
    const logger = inject(MmuLogger);
    logger.warn(`Tried to access Miele Move at "${state.url}", but the service user wasn't approved by Miele yet`);

    return router.createUrlTree(['/user/organization/approval-pending'], {
      queryParams: {
        redirect: state.url
      }
    });
  };
}
